var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopySharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ion:copy-sharp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.625 37.5H10.625C10.1277 37.5 9.65081 37.3025 9.29917 36.9508C8.94754 36.5992 8.75 36.1223 8.75 35.625V10C8.75 9.66848 8.8817 9.35054 9.11612 9.11612C9.35054 8.8817 9.66848 8.75 10 8.75H35.625C36.1223 8.75 36.5992 8.94754 36.9508 9.29917C37.3025 9.65081 37.5 10.1277 37.5 10.625V35.625C37.5 36.1223 37.3025 36.5992 36.9508 36.9508C36.5992 37.3025 36.1223 37.5 35.625 37.5Z",
    fill: "#076AFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.75 6.25H31.25V4.375C31.25 3.87772 31.0525 3.40081 30.7008 3.04917C30.3492 2.69754 29.8723 2.5 29.375 2.5H4.6875C4.10734 2.5 3.55094 2.73047 3.1407 3.1407C2.73047 3.55094 2.5 4.10734 2.5 4.6875V29.375C2.5 29.8723 2.69754 30.3492 3.04917 30.7008C3.40081 31.0525 3.87772 31.25 4.375 31.25H6.25V8.75C6.25 8.08696 6.51339 7.45107 6.98223 6.98223C7.45107 6.51339 8.08696 6.25 8.75 6.25Z",
    fill: "#076AFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySharp);
export default __webpack_public_path__ + "static/media/copy-sharp.2c1d1631ced522e4da747ec560b2fc84.svg";
export { ForwardRef as ReactComponent };